export const IMPACT_CLASSES = {
  Low: 'l-impact',
  Medium: 'm-impact',
  High: 'h-impact',
  'Not assessed': 'na-impact'
} as const;
